import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { DPPayPeriod, DPEmployeePayment, DPProviderPayment } from "Shared/types/Payments";
import queries from "Shared/queries";
import { GetPayPeriodQuery, GetPayPeriodQueryVariables } from "generated/graphql";
import { PayGroup } from "Shared/types/EmployeeProfiles";

const initialPayPeriod: DPPayPeriod = {
  id: "",
  startsAt: "",
  endsAt: "",
  name: "",
  summary: {
    netEarningsAmountCents: 0,
    totalTransferredEarlyAmountCents: 0,
    totalFeeAmountCents: 0,
    remainderAmountCents: 0,
    negativeBalancePaidSettlementAmountCents: 0,
  },
  employeePayments: { items: [] as DPEmployeePayment[] },
  providerPayments: { items: [] as DPProviderPayment[] },
};

export interface UsePayPeriodQueryParams {
  payGroups: PayGroup[];
  payGroupIndex: number;
  payPeriodIndex: number;
  employeeProfileId: string;
}
export function usePayPeriodQuery(params: UsePayPeriodQueryParams) {
  const { payGroups, payGroupIndex, payPeriodIndex, employeeProfileId } = params;
  const [payPeriod, setPayPeriod] = useState<DPPayPeriod>(
    initialPayPeriod
  );

  const payGroup = payGroups[payGroupIndex];
  const providerAccountId = payGroup.providerAccountId;
  const newPayPeriodId = payGroup.payPeriods[payPeriodIndex].id!;

  const { data, loading } = useQuery<GetPayPeriodQuery, GetPayPeriodQueryVariables>(
    queries.GET_PAY_PERIOD,
    {
      variables: {
        payPeriodId: newPayPeriodId,
        employeeProfileId,
        providerAccountId,
      },
    }
  );

  useEffect(() => {
    const fetchedPayPeriod = data?.employeeProfile?.providerAccount?.payPeriod;
    if (!loading && fetchedPayPeriod && fetchedPayPeriod.id !== payPeriod.id) {
      setPayPeriod(fetchedPayPeriod);
    }
  }, [data, loading, payPeriod.id]);

  return payPeriod;
}
